
import { defineComponent, ref } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'CreatePasword',
  emits: ['nextStep'],
  setup(_, { emit }) {
    const store = useStore()
    const password = ref('')
    const passwordConfirm = ref('')

    function nextStep() {
      if (
        password.value.length >= 8 &&
        password.value === passwordConfirm.value
      ) {
        store.dispatch('auth/storePassword', password.value)
        emit('nextStep', 2)
      }
    }

    return {
      store,
      password,
      passwordConfirm,
      nextStep
    }
  }
})
